import { getUsersData } from "Areas/Settings/users/redux/selectors";
import panelActionCreators from "Areas/SharedFeatures/accessLevelsEditorPanel/redux/actionCreators";
import { getAccessLevelNew } from "Areas/SharedFeatures/accessLevelsEditorPanel/redux/selectors";
import { security } from "Common/permissions";
import filter from "lodash/filter";
import map from "lodash/map";
import { connect } from "react-redux";
import parentActionCreators from "../../accessLevels/redux/actionCreators";
import actionCreators from "../../accessLevelsEditorPanel/redux/actionCreators";
import AccessLevelsCreator from "./accessLevelsCreator";
const mapStateToProps = (state) => ({
    selfUserId: security.getCurrentUserId(),
    users: getUsersData(state),
    accessLevelNew: getAccessLevelNew(state)
});
const mapDispatchToProps = (dispatch, ownProps) => ({
    onSave: (draft) => {
        Promise.all(map(filter(draft, "Changed"), accessLevel => !accessLevel.Deleted
            ? dispatch(actionCreators.saveAccessLevel(accessLevel))
            : dispatch(actionCreators.deleteAccessLevel(accessLevel)))).then(() => {
            dispatch(panelActionCreators.setAccessLevelNew(undefined));
            dispatch(parentActionCreators.getPermissions(ownProps.entityId, ownProps.entityType));
        });
    }
});
export default connect(mapStateToProps, mapDispatchToProps)(AccessLevelsCreator);
